import type CarrierBuildingLocation from '~/types/CarrierBuildingLocation';

import { carrierHashMap } from '~/constants/carriers';
import { type WeightUnit } from '~/constants/weight';
import { type SavedAPIAddress } from '~/types/APIAddress';
import { normalizeCarrierName } from '~/types/Carrier';

import { ActionKeys } from './constants';

// TODO: Add types to function params
export const getTransactionsForCarrier = (
  carrier: string,
  startDate: string,
  endDate: string,
  preferredMassUnit: WeightUnit,
) =>
  <const>{
    payload: {
      carrier,
      endDate,
      preferredMassUnit,
      startDate,
    },
    type: ActionKeys.PICKUPS_FETCH_TRANSACTIONS,
  };

// TODO: Add types to function params
export const getTransactionsForCarrierSuccess = (payload: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  serviceLevelInfo: any;
  totalTransactions: number;
  totalWeight: number;
  transactionObjectIds: string[];
}) =>
  <const>{
    payload,
    type: ActionKeys.PICKUPS_FETCH_TRANSACTIONS_SUCCESS,
  };

// TODO: Add types to function params
export const getTransactionsForCarrierError = (errorMessage) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.PICKUPS_FETCH_TRANSACTIONS_ERROR,
  };

// TODO: Add types to function params
export const getCarrierAccountId = (carrier: string) => {
  const carrierObj = carrierHashMap[normalizeCarrierName(carrier)];
  return <const>{
    payload: {
      carrier: carrierObj.id,
    },
    type: ActionKeys.PICKUPS_FETCH_CARRIER_ACCOUNT_ID,
  };
};

// TODO: Add types to function params
export const getCarrierAccountIdSuccess = (payload) =>
  <const>{
    payload,
    type: ActionKeys.PICKUPS_FETCH_CARRIER_ACCOUNT_ID_SUCCESS,
  };

// TODO: Add types to function params
export const getCarrierAccountIdError = (errorMessage) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.PICKUPS_FETCH_CARRIER_ACCOUNT_ID_ERROR,
  };

// TODO: Add types to function params
export const getCarrierBuildingLocationTypes = (carrierObj) =>
  <const>{
    payload: {
      carrier: carrierObj.id,
    },
    type: ActionKeys.PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES,
  };

export const getCarrierBuildingLocationTypesSuccess = (payload: CarrierBuildingLocation[]) =>
  <const>{
    payload,
    type: ActionKeys.PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_SUCCESS,
  };

// TODO: Add types to function params
export const getCarrierBuildingLocationTypesError = (errorMessage: unknown) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_ERROR,
  };

// TODO: Add types to function params
export const sendPickupsRequest = (
  carrierAccountId: null | string | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  buildingLocationType: any,
  address: SavedAPIAddress,
  transactionObjectIds: string[],
  startTime: string,
  endTime: string,
  timeZone: null | string | undefined,
) =>
  <const>{
    payload: {
      address,
      buildingLocationType,
      carrierAccountId,
      endTime,
      startTime,
      timeZone,
      transactionObjectIds,
    },
    type: ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST,
  };

// TODO: Add types to function params
export const sendPickupsRequestSuccess = (payload: {
  confirmationCode: string;
  pickupDate: null | string | undefined;
  pickupReadyByTime?: null | string | undefined;
  timeZone: string;
}) =>
  <const>{
    payload,
    type: ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST_SUCCESS,
  };

// TODO: Add types to function params
export const sendPickupsRequestError = (errorMessage: unknown) =>
  <const>{
    payload: {
      errorMessage,
    },
    type: ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST_ERROR,
  };

export type PickupsActions =
  | ReturnType<typeof getCarrierAccountId>
  | ReturnType<typeof getCarrierAccountIdError>
  | ReturnType<typeof getCarrierAccountIdSuccess>
  | ReturnType<typeof getCarrierBuildingLocationTypes>
  | ReturnType<typeof getCarrierBuildingLocationTypesError>
  | ReturnType<typeof getCarrierBuildingLocationTypesSuccess>
  | ReturnType<typeof getTransactionsForCarrier>
  | ReturnType<typeof getTransactionsForCarrierError>
  | ReturnType<typeof getTransactionsForCarrierSuccess>
  | ReturnType<typeof sendPickupsRequest>
  | ReturnType<typeof sendPickupsRequestError>
  | ReturnType<typeof sendPickupsRequestSuccess>;
